module.exports = __webpack_public_path__ + "img/receipt-outline-blue.6e0aff91.svg";